export async function getArtist() {
    const artist = await fetchData('GET', 'https://api.spotify.com/v1/artists/4Z8W4fKeB5YxbusRsdQVPb');
}

export async function searchArtist(string, limit = 10) {
    string = string.replace(' ', '%2520');

    const query = `artist%3A${string}`;

    return await fetchData('GET', `https://api.spotify.com/v1/search?q=${query}&type=artist&market=FR&limit=${limit}`);
}

export async function searchArtistPlaylists(artistName, limit = 10) {
    return await fetchData('GET', `https://api.spotify.com/v1/search?q=${artistName}&type=playlist&market=FR&limit=${limit}`);
}

export async function getArtistById(artistId) {
    return await fetchData('GET', `https://api.spotify.com/v1/artists/${artistId}`);
}

export async function getAlbumByArtistId(artistId) {
    return await fetchData('GET', `https://api.spotify.com/v1/artists/${artistId}/albums`);
}

export async function getRelatedArtists(artistId) {
    return await fetchData('GET', `https://api.spotify.com/v1/artists/${artistId}/related-artists`);
}

export async function getPlaylistById(playlistId) {
    return await fetchData('GET', `https://api.spotify.com/v1/playlists/${playlistId}`);
}

export async function getBrowseCategoryPlaylistsById(categoryId, offset = 0, limit = 20) {
    return await fetchData('GET', `https://api.spotify.com/v1/browse/categories/${categoryId}/playlists?offset=${offset}&limit=${limit}`);
}

export async function getAllPlaylistsFromCategoryById(categoryId) {
    let fetchedAllDataFlag = false;

    let playlists = [];

    let offset = 0;
    let limit = 0;

    while (false === fetchedAllDataFlag) {
        offset = offset + limit;
        limit = 50;

        playlists = playlists.concat(await findPlaylists(limit, offset))
    }

    return playlists;

    async function findPlaylists(limit, offset) {

        const data = await fetchData('GET', `https://api.spotify.com/v1/browse/categories/${categoryId}/playlists?offset=${offset}&limit=${limit}`);

        if (data.playlists && data.playlists.items.length > 0) {
            return data.playlists.items;
        }

        fetchedAllDataFlag = true;
    }
}

export function getArtistMostPopularPlaylist(playlists) {
    const sortedPlaylists = playlists.sort((a, b) => b.followers.total - a.followers.total);

    return sortedPlaylists.length > 0 ? sortedPlaylists[0] : null;
}

export async function getMostPopularArtistPlaylistBySpotify(artist) {
    let playlist = null;
    let isOwnerSpotify = false;
    let limit = 0;
    let offset = 0;
    let size = 20;

    while (false === isOwnerSpotify) {
        offset = offset + limit
        limit = limit + size;
        playlist = await findPlaylists(limit, offset)
    }

    return playlist;

    async function findPlaylists(limit, offset) {

        const data =  await fetchData('GET', `https://api.spotify.com/v1/search?q=${artist.name}&type=playlist&market=FR&limit=${limit}&offset=${offset}`);

        if (
            data.playlists &&
            data.playlists.items.length > 0
        ) {
            const items = data.playlists.items
            let i = 0;
            for (i; i < items.length; i++) {
                const playlist = items[i];

                if ('spotify' === playlist.owner.id) {
                    isOwnerSpotify = true;
                    return playlist;
                }
            }

            return false;
        }
    }
}

export async function getVisibilityScore(artist) {
    const baseArray = {
        'popularity': 95,
        'score': 53,
    }

    const popularity = artist.popularity;
    let score = Math.ceil((popularity * baseArray['score']) / baseArray['popularity']);

    if (score < 3) {
        score = 3;
    }

    if (score < 1) {
        score = 0;
    }

    return score
}

export async function getAuth() {
    const clientId = '812d929e70b24899971a2bb48133effa';
    const clientSecret = 'c6734d772399419aa10ba208f2d2ff3a';

    const url = 'https://accounts.spotify.com/api/token';
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    const body = new URLSearchParams({
        'grant_type': 'client_credentials',
        'client_id': clientId,
        'client_secret': clientSecret
    });

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body
        });

        const data = await response.json();
        const now = new Date();

        data.expires_at = new Date(now.getTime() + (Number(data.expires_in) * 1000));
        sessionStorage.setItem('spotify_data', JSON.stringify(data));

        return  data.access_token;
    } catch (error) {
        throw error;
    }
}

async function fetchData(method, url, body = null) {
    const now = new Date();
    const sessionData = JSON.parse(sessionStorage.getItem('spotify_data')) ?? null;

    const accessToken = (!sessionData || sessionData && (now > new Date(sessionData.expires_at))) ?
        await getAuth() :
        sessionData.access_token;

    const headers = {
        'Authorization': `Bearer ${accessToken}`
    };

    const params = {
        method: method,
        headers
    }

    if (null !== body) {
        params.body = body;
    }

    try {
        const response = await fetch(url, params);
        return await response.json();
    } catch (error) {
        throw error;
    }
}